<template>
    <div class="category">
        <div class="off-box">
            <div class="off-title">
                <i class="el-icon-s-ticket"></i>
                <span>Today Discount</span>
            </div>
            <div class="discount-box">
                <i class="iconfont icon-waimai"></i>
                <span>
                    No delivery free for orders over £10
                </span>
            </div>
            <div style="flex:1;"></div>
            
        </div>
        <div class="cate-search">
            <i class="el-icon-search"></i>
            <input type="text" placeholder="Search" :clearable="true">
        </div>
        <div v-for="item in categoryList"  :key="item.catId" :class="['cate-item',{'now-cate': item.catId==value}]" 
            @click="chooseCateId(item)">
            <span>{{ item.categoryName }}</span>
            <i class="el-icon-arrow-right"></i>
        </div>
    </div>
</template>
<script>
export default {
    model: {
        prop: 'value',
        event: 'input',
    },
    props: {
        categoryList: {
            type: Array,
            default: () => []
        },
        value: {
            type: [String, Number],
            default: () => ''
        }
    },
    data() {
        return {
            
        }
    },
    mounted() {

    },
    methods: {
        chooseCateId(item) {
            this.$emit('input', item.catId)
        }
    }
}
</script>
<style lang="scss" scoped>
    .category {
        .off-box {
            height: 180px;
            background-color: #D61409;
            border-radius: 8px;
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25), 0px 2px 4px rgba(0, 0, 0, 0.25);
            display: flex;
            flex-direction: column;

            .off-title {
                font-size: 24px;
                font-weight: 800;
                padding-top: 20px;
                color: #fff;
                display: flex;
                align-items: center;
                padding-left: 20px;

                i {
                    color: #fff;
                    font-size: 28px;
                    margin-right: 10px;
                }
            }
            .discount-box {
                margin-top: 20px;
                background-color: rgba(0, 0, 0, 0.25);
                padding: 10px;
                color: #fff;
                font-weight: 800;
                i {
                    margin-right: 6px;
                    font-size: 20px;
                }
            }
        }
        .cate-search {
            margin: 15px 0;
            height: 48px;
            display: flex;
            align-items: center;
            background-color: #fff;
            box-shadow: 0px 3px 5px #8F9698;
            border-radius: 4px;
            padding: 0 20px;

            i {
                font-size: 20px;
                color: #9A47EE;
            }

            input {
                background-color: #fff;
                padding-left: 10px;
                font-size: 18px;
                font-weight: 600;
                color: #0A191E;
            }
        }
        .cate-item {
            padding: 12px 20px;
            font-size: 15px;
            font-weight: bold;
            background-color: #fff;
            border-bottom: 0.5px solid rgba(0, 0, 0, 0.25);
            cursor: pointer;
            display: flex;
            align-items: center;
            // transition: all ease-in-out .1s;
            &:hover {
                background-color: #f2f2f2b3;
            }
            span {
                flex: 1;
            }
            i {
                color: #000;
                font-weight: 600;
            }
        }
        .cate-item:nth-child(1) {
            border-radius: 4px 4px 0 0;
            background-color: red;
            color: red;
        }
        .now-cate {
            background-color: #F2F2F2;
            color: #000;
        }
    }

</style>